export function useSanitize() {
  /** Strip all HTML/script tags — use on every plain-text field before sending to API */
  function sanitizeText(val: string): string {
    return (val || '').replace(/<[^>]*>/g, '').trim();
  }

  /** Block javascript: / data: / vbscript: URLs to prevent XSS and open-redirect */
  function sanitizeUrl(val: string): string {
    const trimmed = (val || '').trim();
    if (/^(javascript|data|vbscript):/i.test(trimmed)) return '';
    return trimmed;
  }

  /** Sanitize a whole FormData payload — applies sanitizeText to every string field */
  function sanitizePayload(data: Record<string, any>): Record<string, any> {
    const clean: Record<string, any> = {};
    for (const key in data) {
      const val = data[key];
      if (typeof val === 'string') {
        clean[key] = key.toLowerCase().includes('url') || key.toLowerCase().includes('website') || key.toLowerCase().includes('link')
          ? sanitizeUrl(val)
          : sanitizeText(val);
      } else {
        clean[key] = val;
      }
    }
    return clean;
  }

  return { sanitizeText, sanitizeUrl, sanitizePayload };
}
